export const DEFAULT_APP_ENVS = ['dev', 'prod'];
export const DELAY_AFTER_S3_FILE_UPLOAD = 5000;
export const LINK_SIGNUP = 'https://forms.gle/1r5kxsk9151mnaLX8';
